import React, { useState, useCallback, useEffect } from 'react';
import { Ontotis, OntotisDropDown, Unit } from '../../../utils/types';
import { getOntotisDropDown, getUnitsDropDown } from '../../../utils/apicall/commonApi';
import NotFound from '../../common/404';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { DefaultOntotis } from '../../../utils/data';
import { addOntotis } from '../../../utils/apicall/ontotisApi';
import { handleError, ApiError } from '../../../utils/error/error';
import GeneralErrorPage from '../../common/general-error';
import { processError } from '../../../utils/error/errorUtils';
import ErrorMessage from '../../../components/errorMessage';
import { authService } from '../../../utils/authServices';
import { CONFIG } from '../../../utils/config';
import TextEditor from '../../../components/TextEditor';

const OntotitaAdd: React.FC = () => {
    const [units, setUnits] = useState<Unit[]>([]);
    const [ontotisDropDown, setOntotisDropDown] = useState<OntotisDropDown[]>([]);
    const [formData, setFormData] = useState<Ontotis>(DefaultOntotis);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const [errors, setErrors] = useState<{ [key: string]: string[] }>({});
    const [successMessage, setSuccessMessage] = useState<string | null>(null);
    const navigate = useNavigate();
    const location = useLocation();
    const state = location.state as { returnTo?: string; id?: string,  address?: string, tk?: string,city?: string, } || {};
    const { returnTo = "/", id = null,  address=null, tk=null,city=null} = state;

    //console.log(address);
    // Validate and pre-select "Οντότητα" if `id` is valid
   useEffect(() => {
        if (id && !isNaN(Number(id)) && Number(id) >= 0) {
          setFormData((prevData) => ({ ...prevData, parent_id: parseInt(id, 10) }));
        }
      }, [id]); 

    const loadUnits = useCallback(async () => {
        try {
            const response = await getUnitsDropDown();
            if (response) setUnits(response);
            else console.warn('Expected an array but got:', response);
        } catch (error) {
            handleError(error);
          if (error instanceof ApiError && error.statusCode === 404) {
              return <NotFound />;
          } else {
              console.error('An unexpected error occurred:', error);
             return <GeneralErrorPage />;
            }
        }
    }, []);

    const loadOntotisDropDown = useCallback(async () => {
        try {
            const response = await getOntotisDropDown();
            //console.log('test--', response);
            if (response) setOntotisDropDown(response);
            else console.warn('Expected an array but got:', response);
        } catch (error) {
            handleError(error);
            processError(error, setErrors, setErrorMessage, setSuccessMessage);
                if (error instanceof ApiError && error.statusCode === 404) {
                    return <NotFound />;
                } else {
                    console.error('An unexpected error occurred:', error);
                    return <GeneralErrorPage />;
                }
         }
    }, []);
    useEffect(() => {
        const returnTo = location.state?.returnTo || "-1";
        //console.log("returnTo value:", returnTo);
        const id = location.state?.id || "-1";
      //  console.log("id value:", id);
      }, [location]);
      
    useEffect(() => {
        loadUnits();
        loadOntotisDropDown();
       
        authService.refreshAuthToken();
    }, [loadUnits, loadOntotisDropDown]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setSuccessMessage(null);
        setErrorMessage(null);
      
        try {
            const response = await addOntotis(formData);
            setSuccessMessage('Η οντότητα προστέθηκε με επιτυχία!'); // Custom success message
          
            if (id) {
                setTimeout(() => {
                    // Go back to the previous page and pass a `refresh` flag
                    navigate(returnTo, { state: { refresh: true } });
                  }, 300); // Adjust delay if necessary*/
                /*setTimeout(() => {
                  navigate(-1);
                
                    window.location.reload();
                 
                }, 300);*/
               }else{
                setTimeout(() => {
                  navigate(CONFIG.urls.getOntotitaUrl_Admin());
                  setTimeout(() => {
                    window.location.reload();
                  }, 100);
                }, 300);
               }
      
          
        } catch (error) {
            handleError(error);
            processError(error, setErrors, setErrorMessage, setSuccessMessage);
            if (error instanceof ApiError && error.statusCode === 404) {
                return <NotFound />;
            } else {
                console.error('An unexpected error occurred:', error);
                return <GeneralErrorPage />;
            }

        }
    };
    const handleAddress = () => {
        if (address && city && tk){
            setFormData((prevData) => ({ ...prevData, 
                address: address, // Replace with parent entity's address
                city: city,      // Replace with parent entity's city
                postalCode: tk,       // Replace with parent entity's postal code
             }));
        }
       
       
    };
   
    const handleChangeTextEditor = (field: string) => (content: string) => {
        setFormData((prev) => ({
          ...prev,
          [field]: content,
        }));
      };

    return (
        <div className="content">
            <section className="ontotita py-5">
                <div className="container mt-4">
                    <div className="card p-5">
                        <h2 className="h5 mb-2 text-primary">Προσθήκη Οντότητας</h2>
                        <hr />
                        <form className="mt-2" onSubmit={handleSubmit}>
                        {successMessage && (
                            <div className="alert alert-success alert-dismissible fade show" role="alert">
                                {successMessage}
                                <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="alert"
                                aria-label="Close"
                                ></button>
                            </div>
                            )}
                            {errorMessage && (
                            <div className="alert alert-danger alert-dismissible fade show" role="alert">
                                 {errorMessage}
                                <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="alert"
                                aria-label="Close"
                                ></button>
                            </div>
                            )}
                            <div className="row mb-3">
                                <div className="mb-3">
                                    <label htmlFor="unit_id" className="form-label">Περιφερειακή Ενότητα</label>
                                    <select id="unit_id" name="unit_id" className="form-select" required onChange={handleChange}>
                                        <option value="">Επιλέξτε Περιφερειακή Ενότητα</option>
                                        {units.map(unit => (
                                            <option key={unit.id} value={unit.id}>
                                                {unit.title}
                                            </option>
                                        ))}
                                    </select>
                                    {errors && errors.hasOwnProperty('unit_id') && (<ErrorMessage message={errors.unit_id[0]} />)}
                                </div>
                                <div className="col-md-6">
                                    <label htmlFor="parent_id" className="form-label">Γονική Οντότητα</label>
                                   {/* <select id="parent_id" name="parent_id" className="form-select" required onChange={handleChange}>
                                        <option value="">Επιλέξτε Γονική Οντότητα</option>
                                        {ontotisDropDown.map(item => (
                                            <option key={item.id} value={item.id}>
                                                {item.title}
                                            </option>
                                        ))}
                                        </select>*/}
                                        {/*   <select
                                                id="parent_id"
                                                name="parent_id"
                                                className="form-select"
                                                value={formData.parent_id || ''} // Ensure controlled component behavior
                                                required
                                                onChange={handleChange}
                                            >
                                                <option value="">Επιλέξτε Γονική Οντότητα</option>
                                                {ontotisDropDown.map((item) => (
                                                    <option key={item.id} value={item.id}>
                                                        {item.title}
                                                    </option>


                                                ))}
                                            </select>*/}


                                                <select
                                                    id="parent_id"
                                                    name="parent_id"
                                                    className="form-select"
                                                    value={formData.parent_id || ''} // Ensure controlled component behavior
                                                    onChange={handleChange}
                                                >
                                                    <option value="">Επιλέξτε Γονική Οντότητα</option>
                                                    {ontotisDropDown.map((item) => (
                                                        <option 
                                                            key={item.id} 
                                                            value={item.id} 
                                                            disabled={!item.can_edit} // Disable if can_edit is false
                                                        >
                                                            {item.title}
                                                        </option>
                                                    ))}
                                                </select>
                                    {errors && errors.hasOwnProperty('parent_id') && (<ErrorMessage message={errors.parent_id[0]} />)}
                                </div>
                                <div className="col-md-6">
                                    <label htmlFor="title" className="form-label">Τίτλος Οντότητας</label>
                                    <input type="text" id="title" name="title" className="form-control" required onChange={handleChange} />
                                    {errors && errors.hasOwnProperty('title') && (<ErrorMessage message={errors.title[0]} />)}
                                </div>
                               
                            </div>
                            <div className="mb-3">
                                <label htmlFor="description" className="form-label">Περιγραφή</label>
                                <TextEditor value={formData?.description || ""} onChange={handleChangeTextEditor("description")}/>
                              {/*  <textarea id="description" name="description" className="form-control" rows={3} onChange={handleChange}></textarea>*/} 
                                {errors && errors.hasOwnProperty('description') && (<ErrorMessage message={errors.description[0]} />)}
                            </div>
                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <label htmlFor="subontotisname" className="form-label">Όνομα Υπό-οντοτήτων</label>
                                    <input type="text" id="subontotisname" name="subontotisname" className="form-control" onChange={handleChange} />
                                    {errors && errors.hasOwnProperty('subontotisname') && (<ErrorMessage message={errors.subontotisname[0]} />)}
                                </div>
                                <div className="col-md-6">
                                    <label htmlFor="customorder" className="form-label">Ορισμός Ταξινόμησης</label>
                                    <input type="number" id="customorder" name="customorder" className="form-control" defaultValue={0} onChange={handleChange} />
                                    {errors && errors.hasOwnProperty('customorder') && (<ErrorMessage message={errors.customorder[0]} />)}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <label htmlFor="address" className="form-label">Διεύθυνση</label>
                                    <input type="text" id="address" name="address" className="form-control" value={formData.address!} onChange={handleChange} />
                                    {errors && errors.hasOwnProperty('address') && (<ErrorMessage message={errors.address[0]} />)}
                                </div>
                                <div className="col-md-4">
                                    <label htmlFor="city" className="form-label">Πόλη</label>
                                    <input type="text" id="city" name="city" className="form-control" value={formData.city!} onChange={handleChange} />
                                </div>
                                <div className="col-md-2">
                                    <label htmlFor="postalCode" className="form-label">ΤΚ</label>
                                    <input type="text" id="postalCode" name="postalCode" className="form-control" value={formData.postalCode!}  onChange={handleChange} />
                                    {errors && errors.hasOwnProperty('postalCode') && (<ErrorMessage message={errors.postalCode[0]} />)}
                                </div>
                            </div>
                            <div className="mb-3">
                            {id && address && city && tk && (
                                <button
                                    className="btn btn-secondary btn-sm"
                                    onClick={(e) => {
                                        e.preventDefault(); // Prevent form submission
                                        handleAddress();
                                    }}
                                >
                                    Προσθήκη Δ/νσης Από την Γονική Οντότητα
                                </button>
                            )}
                                </div>
                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <label htmlFor="phone1" className="form-label">Τηλέφωνο 1</label>
                                    <input type="text" id="phone1" name="phone1" className="form-control" onChange={handleChange} />
                                    {errors && errors.hasOwnProperty('phone1') && (<ErrorMessage message={errors.phone1[0]} />)}
                                </div>
                                <div className="col-md-6">
                                    <label htmlFor="phone2" className="form-label">Τηλέφωνο 2</label>
                                    <input type="text" id="phone2" name="phone2" className="form-control" onChange={handleChange} />
                                    {errors && errors.hasOwnProperty('phone2') && (<ErrorMessage message={errors.phone2[0]} />)}
                                </div>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="email" className="form-label">Email</label>
                                <input type="email" id="email" name="email" className="form-control" onChange={handleChange} />
                                {errors && errors.hasOwnProperty('email') && (<ErrorMessage message={errors.email[0]} />)}
                            </div>
                            <div className="text-end mt-4">
                                <button type="submit" className="btn btn-primary"><i className="bi bi-save"></i> Αποθήκευση</button>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default OntotitaAdd;
